// Don't reference original objects in dev console, otherwise they cannot be garbage collected.
const clone = (data) => {
    if (data && 'error' in data && data.error instanceof Error) {
        data.error = JSON.parse(JSON.stringify(data.error, Object.getOwnPropertyNames(data.error)));
    }
    try {
        return structuredClone(data);
    }
    catch (error) {
        try {
            return JSON.parse(JSON.stringify(data));
        }
        catch (error) {
            return { data: 'error while serializing data' };
        }
    }
};
export class Logger {
    api;
    constructor(api = console) {
        this.api = api;
    }
    debug = (msg, dataOrError) => this.api.debug(msg, clone(dataOrError));
    info = (msg, dataOrError) => this.api.info(msg, clone(dataOrError));
    warn = (msg, dataOrError) => this.api.warn(msg, clone(dataOrError));
    error = (msg, dataOrError) => this.api.error(msg, clone(dataOrError));
}
//# sourceMappingURL=logger.js.map